var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.104a8.829 8.829 0 0 1 8.828-8.828z",
    fill: "#f5f5f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#73af00",
    d: "M0 200.09h512V311.9H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.6a85b2deb2bb138510a06502af36c73d.svg";
export { ForwardRef as ReactComponent };